// pdf.js (the kiosk NDA viewer) calls these without checking for them, which
// crashes browsers older than Safari 17.4 / Chrome 119 (Promise.withResolvers)
// and Safari 18 / Chrome 126 (URL.parse), e.g. kiosk tablets' WebViews.
// Imported first in instrumentation-client.ts so it runs before any app code.

type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

// Our TypeScript lib predates Promise.withResolvers, so describe it here.
const PromiseConstructorWithResolvers = Promise as PromiseConstructor & {
  withResolvers?: <T>() => PromiseWithResolvers<T>;
};

if (typeof PromiseConstructorWithResolvers.withResolvers !== "function") {
  PromiseConstructorWithResolvers.withResolvers = <T>() => {
    let resolve!: PromiseWithResolvers<T>["resolve"];
    let reject!: PromiseWithResolvers<T>["reject"];
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

if (typeof URL.parse !== "function") {
  URL.parse = (url: string | URL, base?: string | URL) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
